import { Col, Row, Card, CardBody } from "reactstrap";

//images
import Mempercayainya1 from '../../assets/images/home/modal/mempercayainya-1.png';
import Mempercayainya2 from '../../assets/images/home/modal/mempercayainya-2.png';
import Mempercayainya3 from '../../assets/images/home/modal/mempercayainya-3.png';
import Mempercayainya4 from '../../assets/images/home/modal/mempercayainya-4.png';
import Mempercayainya5 from '../../assets/images/home/modal/mempercayainya-5.png';
import QuotationMark from '../../assets/images/home/modal/quotation-mark.svg';

const Mempercayai = () => {
  return(
    <>
      <Row>
        <Col md="1"></Col>
        <Col md="10" className="text-center modal-home">
          <h6 className="mb-3">
            MEMPERCAYAINYA DAN MENYEBARKANNYA
          </h6>
          <p>
            Jika kamu mempercayai informasi yang belum jelas kebenarannya dapat mengakibatkan berbagai dampak hingga membahayakan dirimu, mencangkup:
          </p>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Mempercayainya1} alt="mempercayainya-1"/>
            <p className="mx-2">Informasi tersebut bisa saja merupakan hoaks, yang sengaja disebarkan untuk memperburuk keadaan yang terjadi..</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Mempercayainya2} alt="mempercayainya-2" />
            <p className="mx-2">Kamu dapat dilanda rasa panik hingga ketakutan berjangka panjang. </p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Mempercayainya3} alt="mempercayainya-3" />
            <p className="mx-2">Dapat membuatmu abai terhadap kebijakan baik dari pemerintah mencakup protokol kesehatan atau regulasi yang telah ditetapkan.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Mempercayainya4} alt="mempercayainya-4" />
            <p className="mx-2">Menjadi bingung membedakan antara mana informasi yang benar dan salah.</p>
          </div>
          <div className="d-flex justify-content-start align-items-center">
            <img src={Mempercayainya5} alt="mempercayainya-5" />
            <p className="mx-2">Informasi ini dapat berakibat fatal hingga menghadirkan korban jiwa. </p>
          </div>
          <p className="mt-3">
            Bagaimana dengan ikut menyebarkannya dan kemudian klaim yang kamu sebarkan terbukti salah?
          </p>
          <p>
            <strong>Pelaku penyebaran hoaks termasuk dalam tindakan hukum</strong>, diatur dalam Undang-Undang No. 11 Tahun 2008 tentang Informasi dan Transaksi Elektronik (UU ITE)
          </p>
          <Card className="card-modal mt-5">
            <CardBody>
              <img src={QuotationMark} alt="quotation-mark" className="quotation-mark" />
              <p className="text-center text-white montserrat">
                Setiap orang yang sengaja menyebarkan berita bohong dan menyesatkan yang mengakibatkan kerugian konsumen dalam transaksi elektronik bisa dikenakan pidana paling lama enam tahun dan/atau denda maksimal Rp 1 miliar.
              </p>
            </CardBody>
          </Card>
          <p className="text-center">
            Menurutmu apakah tindakan ini sudah benar?
          </p>
          <p className="text-center">
            Yuk, <strong>cek jawaban disebelah.</strong>
          </p>
        </Col>
        <Col md="1"></Col>
      </Row>
    </>
  );
}

export default Mempercayai